//src/types/Helper/MaintEnums.ts

export enum MaintRecord {
  Airframe = 'Airframe',
  Engine = 'Engine',
  Propeller = 'Propeller',
  Other = 'Other'
}

export enum MaintEndorsement {
  fifty = '50 Hour',
  hundred = '100 Hour',
  annual = 'Annual',
  ELT = 'ELT',
  Xpdr = 'Transponder',
  PitotStatic = 'Pitot/Static Test',
  custom = 'Custom'
}

export enum InspectionsInsert {
  ADCAI = '<ADCAI>',
  ELT = '<ELT>',
  XPDR = '<XPDR>'
}
